import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-down', 'ChevronDown', [["path",{"d":"M6 9l6 6l6 -6"}]]);